import "./App.css";
import { useState } from "react";
import { auth } from "./firebaseconfig";
import Login, { authorizedEmails } from "./Login";
import { onAuthStateChanged } from "firebase/auth";
import User from "./User";

function App() {
  const [user, setUser] = useState();

  onAuthStateChanged(auth, (user) => {
    setUser(user);
  });

  return (
    <div className="App">
      {!user || !authorizedEmails.includes(user.email) ? <Login /> : <User />}
    </div>
  );
}

export default App;
